// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus';

export const Component = () => (
  <path d='m13.43 2.5-.001 9.069H22.5v1.861h-9.071v9.07h-1.906l-.001-9.07H2.5v-1.86l9.022-.001V2.5h1.907Z' />
);

export const viewBox = '0 0 25 25';
